// Import CSS
import "../css/index.css";

// Import JS
import 'flickity-fade';
import 'flickity-as-nav-for';
import Flickity from 'flickity';
import InfiniteScroll from 'infinite-scroll';

/**
 * Flickity Sliders.
 */
let resizeTimer = [];

// Function to initialize Flickity
function initFlickity() {
    console.log( 'initFlickity' );
    document.querySelectorAll('.ct-featured-posts').forEach(element => {
        const textFlickity = new Flickity(element.querySelector('.ct-featured-posts-text'), {
            prevNextButtons: true,
            pageDots: true,
            draggable: false,
            cellAlign: 'left',
            contain: true,
            fade: true,
            autoPlay: false,
            adaptiveHeight: true,
        });

        const imagesFlickity = new Flickity(element.querySelector('.ct-featured-posts-images'), {
            prevNextButtons: false,
            pageDots: false,
            draggable: false,
            cellAlign: 'left',
            contain: true,
            fade: true,
            asNavFor: element.querySelector('.ct-featured-posts-text'),
            adaptiveHeight: true,
        });

        // Store Flickity instances on the element for later access
        element.textFlickity = textFlickity;
        element.imagesFlickity = imagesFlickity;
    });
}

// Function to handle resize
function handleResize() {
    console.log( 'handleResize' );
    initFlickity();
}
initFlickity();

// Initialize Flickity

// Add debounced resize event listener
window.addEventListener('resize', function(){
    clearInterval(resizeTimer);
    resizeTimer = setTimeout( function(){
        handleResize();
    }, 500 );
});

// Popular tags.
document.querySelectorAll('.ct-popular-tags').forEach(element => {
    const tagsFlickity = new Flickity( element, {
            prevNextButtons: true,
            pageDots: false,
            cellAlign: 'left',
            contain: true,
        });
});

/**
 * Calculate Scrollbar Width.
 */
const postContent = document.querySelector(".ct-post-content");
if ( postContent ) {
    postContent.style.setProperty("--scrollbar-width", window.innerWidth - document.documentElement.clientWidth + "px");
}

/**
 * Navigation - Handle max menu items.
 */
document.querySelectorAll('.ct-is-submenu > a').forEach(element => {
    element.addEventListener("click", event => {
        event.target.parentNode.classList.toggle('ct-is-active');
        event.preventDefault();
    });
});

/**
 * Remove empty post content divs
 */
document.addEventListener('DOMContentLoaded', function() {
    var postContent = document.querySelector('.ct-page-template .ct-post-content');
    if (postContent && postContent.innerHTML.trim() === '') {
        postContent.remove();
    }
});

/**
 * Remove the # from footer nav headings
 */

// Select all elements with the class .ct-secondary-nav-heading
const elements = document.querySelectorAll('.ct-secondary-nav-heading a');

// Loop through each element
elements.forEach(function(element) {
    // Get the text content of the element
    let text = element.textContent.trim();

    // Check if the text starts with a '#'
    if (text.startsWith('#')) {
        // Remove the first character '#' from the text
        text = text.substring(1);

        // Update the text content of the element
        element.textContent = text;
    }
});


/**
 * Mobile Menu.
 */
document.querySelectorAll('#ct-mobile-nav').forEach(element => document.querySelector('#ct-header .ct-header-container').appendChild( element ) );

document.querySelectorAll('#ct-mobile-nav-trigger').forEach(element => {
    element.addEventListener("click", event => {
        document.body.classList.toggle('ct-mobile-nav-active');
        event.preventDefault();
    });
});

document.querySelectorAll('#ct-mobile-nav .ct-close-btn').forEach(element => {
    element.addEventListener("click", event => {
        document.body.classList.toggle('ct-mobile-nav-active');
        event.preventDefault();
    });
});

/**
 * Enable post share button.
 */
import ClipboardJS from 'clipboard';

new ClipboardJS("#copy");

/**
 * Infinite Scroll Load More Button.
 */
document.addEventListener("DOMContentLoaded", function() {
    const gridElements = document.querySelectorAll('.ct-grid'),
        nextPageElement = document.querySelector('.ct-next');

    if ( nextPageElement && gridElements.length ) {
        const gridElement = gridElements[gridElements.length - 1];

        const infScroll = new InfiniteScroll( gridElement, {
            path: '.ct-next',
            append: '.ct-item',
            button: '.ct-load-more',
            hideNav: '.ct-next',
            history: false,
            scrollThreshold: false,
        });

        infScroll.on('append', function(response, path, items) {
            for (var i = 0; i < items.length; i++) {
                reloadSrcsetImgs(items[i]);
            }
        });

        function reloadSrcsetImgs(item) {
            var imgs = item.querySelectorAll('img[srcset]');
            for (var i = 0; i < imgs.length; i++) {
                var img = imgs[i];
            }
        }
    }
});
